import iconSrc from '@wwe-portal/ui/assets/images/common/enter-code.webp';

export const EnterCodeDialogHead = () => {
  return (
    <div className="relative flex h-full w-full items-center justify-center">
      <div className="border-borderColor18 rounded-full border-[4px] border-solid p-2">
        <img alt="success" height={76} src={iconSrc} width={76} />
      </div>
    </div>
  );
};
